import { Helmet } from "react-helmet";
import { useStore } from "../../zustand/store";
import AffiliateTabs from "./AffiliateTabs";

/* Shared shell for every /affiliate/* page so the affiliate dashboard matches
 * the structure of /admin/users and the user /dashboard:
 *   - pxl_mainWrapper > pxl_rightBar_assets (responsive sidebar margin)
 *   - pxl-rb-header-wrap (page heading + sidebar toggle button)
 *   - AffiliateTabs (sub-navigation between affiliate pages)
 *   - pxl-templates-wrapper > pxl-container-fluid (content area)
 * Pass `hideTabs` for pages that don't belong to the tabbed flow (e.g. Signup).
 */
export default function AffiliatePageLayout({ pageTitle, heading, hideTabs = false, children }) {
    const store = useStore(state => state);

    return (
        <>
            <Helmet><title>{pageTitle}</title></Helmet>
            <div className="pxl_mainWrapper">
                <div className="pxl_rightBar_assets">
                    <div className="pxl-rb-header-wrap">
                        <div className="pxl-headingTop">
                            <h2 className="pxl-rb-header-heading">{heading || pageTitle.split(' · ')[0]}</h2>
                        </div>
                        <div className="pxl-rb-header-right">
                            <div
                                className="pxl-header-toogle-btn"
                                onClick={() => store.updateStore("resMenuToggle", !store.resMenuToggle)}
                            >
                                <svg className="pxl-header-toogle-svg" viewBox="0 0 100 100" width="80">
                                    <path className="pxl-header-toogle-svg-line pxl-header-toogle-svg-line-top"
                                        d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20" />
                                    <path className="pxl-header-toogle-svg-line pxl-header-toogle-svg-line-middle"
                                        d="m 30,50 h 40" />
                                    <path className="pxl-header-toogle-svg-line pxl-header-toogle-svg-line-bottom"
                                        d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    {!hideTabs && <AffiliateTabs />}

                    <div className="pxl-templates-wrapper">
                        <div className="pxl-container-fluid">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
